import { Button, Container } from '../../components';
import styles from './nft-want.module.css';

export default function NFTWant() {
  return (
    <section className={styles.section}>
      <Container variant="container_medium">
        <div className={styles.inner}>
          <div className={styles.block}>
            <div className={styles.title}>Want to create NFT marketplace?</div>
            <div className={styles.text}>
              We will answer all your questions and help you with the platform
              development
            </div>
          </div>
          <span className={styles.button}>
            <Button tag="a" href="/contact" appearance="nft">
              START NOW
            </Button>
          </span>
        </div>
      </Container>
    </section>
  );
}
